import t from "@ext/localization/locale/translate";
export const ReviewPanelTitle = () => {
	return <span>{t("editor.modes.type-filter.comments")}</span>;
};
